import { useDeepCompareEffect } from '../../../../../hooks/useDeepCompareEffect';
import { useThroughputTabStore } from '../../../../../store/strategy-store/strategy-store';
import { setThroughputSelectedInitiatives } from '../../../../../store/strategy-store/strategy-store.actions';
import { FiltersListInitiatives } from '../../components/filters-list/filters-list-initiatives';
import { MAX_SELECTION } from '../../initiative-performance.constants';
import { useContributingInitiatives } from '../../initiative-performance.hooks';

export const FiltersInitiatives = () => {
  const contributingInitiatives = useContributingInitiatives();
  const selectedInitiatives = useThroughputTabStore((state) => state.selectedInitiatives);

  useDeepCompareEffect(() => {
    if (contributingInitiatives.length > 0) {
      setThroughputSelectedInitiatives(contributingInitiatives.slice(0, MAX_SELECTION));
    }
  }, [contributingInitiatives]);

  return (
    <FiltersListInitiatives
      initiatives={contributingInitiatives}
      selectedInitiatives={selectedInitiatives}
      onSelectInitiatives={setThroughputSelectedInitiatives}
    />
  );
};
